module.exports = __webpack_public_path__ + "img/communicator.99276a3a.svg";